import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const pitchList = (params = '') => Http.get(`/admin/ventures/pitches${serialize(params)}`)
export const pitchByID = (params = '') => Http.get(`/admin/ventures/pitches/${params}`)
export const pitchUpdate = (params = '') => Http.patch(`/admin/ventures/pitches/${params.id}`, params)
export const pitchFeature = (id) => Http.post(`/admin/ventures/pitches/${id}/feature`)
export const pitchUnfeature = (id) => Http.delete(`/admin/ventures/pitches/${id}/feature`)
export const pitchRecommend = (id, params) => Http.post(`/admin/ventures/pitches/${id}/recommend`, params)
